import React, { Component } from "react";
import axios from "axios";
import { useNavigation } from "../../utilities/NavigationContext";

const EndPoint = process.env.REACT_APP_API_ENDPOINT;

class BillingSuccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      subscription: null,
      error: null,
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      this.setState({ loading: false, error: "Missing session_id" });
      return;
    }

    this.fetchSubscriptionStatus(sessionId);
  }

  async fetchSubscriptionStatus(sessionId) {
    try {
      const res = await axios.get(
        `${EndPoint}/stripe/subscription/status?sessionId=${sessionId}`,
        { withCredentials: true }
      );

      this.setState({
        subscription: res.data,
        loading: false,
      });
    } catch (err) {
      console.error(
        'fetchSubscriptionStatus error:',
        err.response?.status,
        err.response?.data || err.message
      );
      this.setState({
        loading: false,
        error: 'Unable to verify subscription',
      });
    }
  }


  goToPlanning = () => {
    // match your other pages: planning as main workspace
    this.props.navigate("/planning");
  };

  goToBilling = () => {
    this.props.navigate("/pricing");
  };

  render() {
    const { loading, subscription, error } = this.state;

    if (loading) {
      return (
        <div className="p-5 text-center">
          <h2>Finalising your subscription…</h2>
        </div>
      );
    }

    if (error) {
      return (
        <div className="p-5 text-center bg-slate-100 text-md rounded shadow m-20">
          <h2 className="text-xl font-bold my-4">Something went wrong</h2>
          <p>{error}</p>
          <div className="mt-10">
            <button
              onClick={this.goToBilling}
              className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4"
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="p-5 text-center bg-slate-100 text-md rounded shadow m-20">
        <h1 className="text-xl font-bold my-4">Subscription Activated 🎉</h1>

        <p>
          <b>Plan:</b> {subscription?.priceNickname}
        </p>
        <p>
          <b>Next Billing Date:</b> {subscription?.nextBillingDate}
        </p>

        <div className="mt-20">
          <button
            onClick={this.goToPlanning}
            className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4 mr-4"
          >
            Go to Planning
          </button>
          <button
            onClick={this.goToBilling}
            className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4"
          >
            Manage Billing
          </button>
        </div>
      </div>
    );
  }
}

const BillingSuccessWithNavigation = (props) => {
  const navigate = useNavigation();
  return <BillingSuccess {...props} navigate={navigate} />;
};

export default BillingSuccessWithNavigation;
